import React, {ReactElement} from 'react';
import INcaseLogo from '../../../../assets/incase-logo-black.svg';
import MediaImage from '../../../incase-domain/components/media/MediaImage';
import {IElementImage} from '../../../incase-domain/elements/image';
import {getBorderStyle} from '../../../utils/style.utils';

interface ElementImageComponentProps {
    element: IElementImage;
}

function ElementImageComponent(props: ElementImageComponentProps): ReactElement {
    const {element} = props;
    const {imageSrc, title, borderRadius} = element;

    return (
        <div className="c-imageElement">
            <MediaImage
                src={imageSrc}
                fallbackSrc={INcaseLogo}
                alt=""
                title={title}
                style={{
                    borderRadius: getBorderStyle(borderRadius),
                }}
            />
        </div>
    );
}

export default ElementImageComponent;
